import {RSAA} from 'redux-api-middleware';
import { MAINTENANCE_STATUS_REQUEST, 
         MAINTENANCE_STATUS_SUCCESS, 
         MAINTENANCE_STATUS_FAILURE } from '../actions/statusActions';
const statusResource = {
  resource: "/admin/status/maintenance",
  contentType: "application/json"
}
export function fetchLoginStatus() {
    return {
        [RSAA]: {
            endpoint: statusResource.resource,
            method: 'GET',
            types: [
              MAINTENANCE_STATUS_REQUEST, 
              MAINTENANCE_STATUS_SUCCESS,
              MAINTENANCE_STATUS_FAILURE
            ]
          }
    }
}